export default "/images/vendor/flag-icon-css/flags/1x1/mn.svg?291814d605941d58335feaba24527a3c";